export default function (namespace = '', options = ' ') {
  namespace = `%c${namespace}`;
  return {
    debug: console.debug.bind(console, namespace, options),
    log: console.log.bind(console, namespace, options),
    warn: console.warn.bind(console, namespace, options),
    error: console.error.bind(console, namespace, options),
  };
}
